<template id="main-page">
	<v-ons-page>
		<div class="background bg-login"></div>

		<div class="content qf-login-box">
			<div class="qf-centered w100">
				<div class="qf-unlock-box">
					<div v-if="welcomeImage" :class="welcomeClass">
						<img :src="welcomeImage" class="login-logo">
					</div>
					<div v-if="unlockStep !== 0" class="qf-lock-username">
						<p>{{welcomeText}}</p>
					</div>
					<div class="qf-current-username">
						<template v-if="unlockStep > 1">
							<v-ons-icon icon="md-account-circle" size="20px"></v-ons-icon><span> {{login.username}}</span>
						</template>
					</div>
				</div>

				<div class="qf-input-holder">
					<transition v-on:after-leave="inputLeaveScreen" name="slide">
						<div v-if="unlockStep === 1" class="login-input-group">
							<v-ons-input
								placeholder="Username" float
								v-model="login.username"
								class="qf-login-input w100"
								modifier="material"
								type="text"
								autocapitalize="off"
								v-on:keyup.enter="unlockStepChange"
							>
							</v-ons-input>
						</div>
						<div v-if="unlockStep === 3" class="login-input-group">
							<v-ons-icon class="qf-change-username" icon="md-arrow-back" tappable @click="changeUsername"></v-ons-icon>
							<v-ons-input
								placeholder="Password" float
								type="password"
								class="qf-login-input w100"
								v-model="login.password"
								modifier="material"
								ref="pass"
								v-on:keyup.enter="unlockStepChange"
							>
							</v-ons-input>
						</div>
						<div v-if="unlockStep === 5" class="login-input-group">
							<v-ons-input
								placeholder="SMS Code" float
								type="password"
								class="qf-login-input w100"
								modifier="material"
								v-model="login.smsCode">
							</v-ons-input>
							<v-ons-icon icon="md-email" tappable @click="sendEmailAlert = true"></v-ons-icon>
						</div>
					</transition>
				</div>
				<v-ons-button v-if="unlockStep !== 0" @click="unlockStepChange" class="w100" :disabled="disabledLoginBtn">
					{{unlockStepBtnText}}
				</v-ons-button>
				<transition name="slide">
					<v-ons-button v-if="unlockStep == 3 & forgotPasswordBtn" modifier="outline" class="qf-forgot-password w100" style="margin: 6px 0" tappable @click="forgotPassword = true">
						Forgot password
					</v-ons-button>
				</transition>
				<v-ons-alert-dialog modifier="rowfooter" :visible.sync="resendSMSAlert">
					<span slot="title">You didn't receive an SMS?</span>
					Do you want us to send you the code again?
					<template slot="footer">
						<v-ons-alert-dialog-button @click="resendSMSAlert = false">Cancel</v-ons-alert-dialog-button>
						<v-ons-alert-dialog-button>YES</v-ons-alert-dialog-button>
					</template>
				</v-ons-alert-dialog>

				<v-ons-alert-dialog modifier="rowfooter" :visible.sync="sendEmailAlert">
					<span slot="title">You didn't receive an SMS?</span>
					Do you want us to send the code to your email?
					<template slot="footer">
						<v-ons-alert-dialog-button @click="sendEmailAlert = false">Cancel</v-ons-alert-dialog-button>
						<v-ons-alert-dialog-button @click="sendCodeViaMail" >YES</v-ons-alert-dialog-button>
					</template>
				</v-ons-alert-dialog>

				<v-ons-alert-dialog modifier="rowfooter" :visible.sync="forgotPassword">
					<span slot="title">Reset your password</span>
					<v-ons-list class="qf-input-list">
						<v-ons-list-item>
							<v-ons-input
									placeholder="Username" float
									type="text"
									class="qf-login-input w100"
									modifier="material"
									v-model="login.username"
							></v-ons-input>
						</v-ons-list-item>
						<v-ons-list-item>
							<v-ons-input
									placeholder="Phone number" float
									type="number"
									class="qf-reset w100"
									modifier="material"
									v-model="login.phone"
							></v-ons-input>
						</v-ons-list-item>
					</v-ons-list>
					<template slot="footer">
						<v-ons-alert-dialog-button @click="forgotPassword = false">Cancel</v-ons-alert-dialog-button>
						<v-ons-alert-dialog-button @click="resetPassword" >RESET</v-ons-alert-dialog-button>
					</template>
				</v-ons-alert-dialog>
			</div>
		</div>
	</v-ons-page>
</template>

<script scoped>

	//import DashboardHome from '@/views/dashboard/DashboardHome';
	import CollectionsHome from "../collections/CollectionsHome";
	import Api from '@/services/api';
    import ApiFormData from "../../services/apiFormData";
	import moment from 'moment';
	import apiFormData from "../../services/apiFormData";

	export default {
		name: 'Login',
		data() {
			return {
				login: {
					username: '',
					password: '',
					smsCode: '',
					phone: ''
				},
				names: '',
				expectSMS: false,
				unlockable: false,
				avatar: null,
				unlockStep: 0,
				resendSMSAlert: false,
				sendEmailAlert: false,
				forgotPasswordBtn: false,
				forgotPassword: false,
				bounced: false,
				disabledLoginBtn: true
			}
		},
		mounted: function () {
			this.$store.commit('shared/setTimerState', false);

			let self = this;

			if(this.bounced){
				this.$ons.notification.toast({
					message: 'Your session has expired. Please login again!',
					class: 'toast-error',
					buttonLabel: 'OK',
					timeout: 3000
				}).then(()=>{
					self.bounced = false;
				});
			}
		},
		created:  function () {
			this.checkLoginStatus();
		},
		computed: {
			unlockStepBtnText() {
				let msg = "Next";

				switch (this.unlockStep) {
					case 1 :
						msg = "Next";
						break;
					case 3 :
						msg = "Send";
						break;
					case 5 :
						msg = "Unlock";
						break;
				}
				return msg;
			},
			welcomeImage() {
                if(this.unlockable){
                    if(this.avatar){
                        return this.avatar;
                    }else {
                        return process.env.VUE_APP_VARIANT + "/img/placeholder-logo.png";
                    }
                }else {
                    return process.env.VUE_APP_VARIANT + "/img/logo.svg";
                }
            },
            welcomeText() {
                if(this.unlockable){
                    return this.names;
                }else {
                    return "Please enter your login details.";
                }
            },
            welcomeClass(){
                if(this.unlockable){
                    return "qf-user-welcome-avatar rounded";
                }else {
                    return "qf-user-welcome-avatar regular"
                }
            }
		},
		methods: {
			fetchAvatar() {
				this.avatar = this.$getCookie('avatar');
			},
			fetchLoginName() {
				this.login.username = this.$getCookie('login_name');
				this.names = this.$getCookie('user_names');
			},
			checkLoginStatus() {
				let self = this;
				Api().get('users/me').then(response => {
					console.log("You have access!", response);
					self.avatar = response.data.avatar;
					self.$setCookie('avatar', response.data.avatar, 14*14400);
					self.$store.commit('shared/setUserAvatar', response.data.avatar);
					self.$store.commit('shared/setUserNames', response.data.names);
					self.$store.commit('shared/setTimerState', true);
					self.navigateToDashboard();
				}).catch(err => {
					if (err.response.status == 401) { //Unauthorized
						self.fetchAvatar();
						self.fetchLoginName();
						if (self.avatar && self.login.username) {
							self.unlockable = true;
							self.unlockStep = 3;
						} else {
							self.unlockable = false;
							self.unlockStep = 1;
						}

					}
				});
			},
			navigateToDashboard() {
				this.$store.commit('navigator/push', {
					extends: CollectionsHome,
					data() {
						return {
							toolbarInfo: {
								backLabel: 'Back to login',
								title: 'Your Dashboard'
							}
						}
					}
				});
			},
			showPopTip(msg, notifClass) {
				if(!notifClass) notifClass ='';
				if(!msg){
					msg ='Incorrect login credentials';
					notifClass = 'toast-error';
				}
				this.$ons.notification.toast({
					message: msg,
					class: notifClass,
					buttonLabel: 'OK!',
					timeout: 7000
				});
				this.forgotPasswordBtn = true
			},
			inputLeaveScreen() {
				if (this.unlockStep < 5) {
					this.unlockStep++;
				}
			},
			unlockStepChange: function () {
				if(this.unlockStep === 1) {
					this.unlockStep++;
				}else {
					if(this.unlockStep === 5 && this.login.smsCode.length < 4){
						this.showPopTip('Incomplete SMS code');
					}else{
						this.loginUser();
					}
				}
			},
			changeUsername: function () {
				if(this.unlockStep === 3) {
					this.unlockStep = 0
				}
			},
			loginUser: function () {

                let payload = new FormData();
                payload.append('grant_type', 'password');
                payload.append('client_id', process.env.VUE_APP_CLIENT_ID);
                payload.append('client_secret', process.env.VUE_APP_CLIENT_SECRET);
                payload.append('username', this.login.username);
                payload.append('password', this.login.password);
                payload.append('sms_code', this.login.smsCode);

				let self = this;
                ApiFormData().post('oauth/v2/token', payload).then(response => {
					console.log(response.data);
					if (!self.login.smsCode && !response.data.access_token) {
						self.expectSMS = true;
						self.unlockStep++;
					} else {
						let now = moment(new Date());

						self.$setCookie('access_token', response.data.access_token, response.data.expires_in);
						self.$setCookie('refresh_token', response.data.refresh_token, 7200);
						now.add(response.data.expires_in, 'seconds');
						//now.add(50, 'seconds');
						self.$setCookie('access_exp_time', now.unix(), 14*14400); //2 Weeks
						self.$setCookie('user_names', response.data.user, 14*14400); //2 Weeks
						self.$setCookie('login_name', payload.username, 14*14400);
						self.checkLoginStatus();
					}

				}).catch((err) => {
					if(err.message === 'wrong code'){
						self.showPopTip('Incorrect SMS Code. Please check if you are using the last code that you have received.');
					}else {
						self.showPopTip();
					}
				});
			},
			sendCodeViaMail(){
				let self = this;
				let payload = new FormData();
				payload.append('username', self.login.username);

				apiFormData().post('sendSmsCodeViaMail', payload).then( () => {
					self.showPopTip('Authentication code successfully sent over e-mail!');
				}).catch(() => {
					self.showPopTip('An error has occurred, please contact the administrator');
				});

			},
			resetPassword(){

                let payload = new FormData();
                payload.append('email', this.login.username);
                payload.append('phoneNumber', this.login.phone);

				let self = this;
                ApiFormData().post('user/resetPassword', payload).then(() => {
					self.showPopTip('Your new password has been successfully sent to your mobile phone.', 'toast-success');
					self.login.password = '';
					self.forgotPassword = false;
				}).catch(() => {
					self.showPopTip('Invalid username and/or phone number.\n' + '\n' + 'You need to enter your phone number including the country code. Try entering your number starting with the country code (e.g. +41... or 0041...).', 'toast-error');
				});
			}
		},
		watch: {
			login: {
				handler(loginObj){
					if(loginObj.username.length>2){
						this.disabledLoginBtn = false;
					}
				},
				deep: true
			}
		}
	}
</script>

<style scoped>
	.qf-centered {
		text-align: center;
		position: relative;
	}
	.qf-input-holder {
		width: 100%;
		display: block;
		padding-bottom: 40px;
		padding-top: 40px;
		text-align: center;
	}

	.qf-user-welcome-avatar {
		margin: 0 auto;
		position: relative;
		display: block;
		overflow: hidden;
	}

    .qf-user-welcome-avatar.rounded {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        border: 3px solid white;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
    }

	.qf-login-header {
		width: 100%;
		padding: 20px;
	}
	.login-input-group{
		transition: all .2s ease;
		transform: translateY(0%);
		opacity: 1;
	}
	.slide-enter-active, .slide-leave-active {
		transform: translateY(100%);
		opacity: 0;
	}
	.login-input-group {
		display: flex;
	}

	.login-input-group .ons-icon {
		margin-left: 20px;
		font-size: 20px;
	}
	.qf-change-username.ons-icon{
		margin-left: 0;
		margin-right: 20px;
	}
	.qf-forgot-password{
		position: absolute;
		left: 0;
		transform: translateY(100%);
		color: #ffffff;
	}
	.qf-current-username {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 24px;
	}
	.qf-current-username span{margin-left: 6px}
	.qf-input-list{ background-color: transparent}
	.qf-input-list .list-item{padding: 0}
	.qf-input-list .list-item > div {padding-right: 0}
</style>
